import styled from "styled-components";

const AddButton = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;

    & button {
        margin-left: 10px;
    }
`;

export default AddButton;
